import React from 'react'
import styled from 'styled-components'
import { array, string, func } from 'prop-types'
import { stripUnit } from 'polished'

import { H4, lineHeights, fontWeights, fontSizes } from 'styles/typography'
import * as spacing from 'styles/spacing'
import { media, mediaDown } from 'styles/media'
import { borderRadius } from 'styles/global'
import { black, white, borderColor } from 'styles/colors'

import BuySection from 'components/buy/BuySection'
import BuyDevices from 'components/buy/BuyDevices'

const Container = styled.div`
  position: static;

  ${mediaDown.medium`
    padding: 20px ${spacing.large};
    border-top: 1px solid ${borderColor};
  `};
`

const Inner = styled.div`
  display: flex;
  align-items: center;

  ${mediaDown.small`
    flex-direction: column;
    align-items: flex-start;
  `};
`

const Tag = styled.div`
  display: inline-block;
  background-color: ${black};
  color: ${white};
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.medium};
  text-transform: uppercase;
  padding: 6px 12px;
  border-radius: ${borderRadius};
  margin-top: ${spacing.medium};

  ${media.small`
    margin-left: ${spacing.xLarge};
    margin-top: 0;
  `};

  ${media.medium`
    padding: 8px 18px;
  `};

  ${media.large`
    margin-left: ${spacing.xxLarge};
  `};

  ${media.xLarge`
    margin-left: ${spacing.xxxLarge};
  `};
`

const MobileHeading = styled(H4)`
  line-height: ${lineHeights.base};
  margin-bottom: ${stripUnit(spacing.small) * 1.5 + 'px'};
`

const FrequencyBuySection = ({ devices, handleDeviceSelect }) => {
  const frequencies = {
    50: {
      title: 'Choose your Low Frequency ePod color created at 50hz',
      variants: devices[0].variants.filter(v => v.title.includes('50')),
      isLocked: false
    },
    1453: {
      title: 'Choose your High Frequency ePod color created at 1453hz',
      variants: devices[0].variants.filter(v => v.title.includes('1453')),
      isLocked: false
    },
    1728: {
      title: 'Choose your High Frequency ePod color created at 1728hz',
      variants: devices[0].variants.filter(v => v.title.includes('1728')),
      isLocked: false
    }
  }

  return (
    <Container>
      {Object.keys(frequencies).map(frequency => (
        <>
          <BuySection heading={frequencies[frequency].title} mutedHeading={frequencies[frequency].isLocked}>
            <MobileHeading className="u-hide-medium-up">{frequencies[frequency].title}</MobileHeading>
            <Inner>
              <BuyDevices
                devices={[{ ...devices[0], variants: frequencies[frequency].variants }]}
                handleDeviceSelect={handleDeviceSelect}
                isLocked={frequencies[frequency].isLocked}
              />
              {frequencies[frequency].isLocked && <Tag>Unlocks {frequencies[frequency].unlockDate}</Tag>}
            </Inner>
          </BuySection>
        </>
      ))}
    </Container>
  )
}

FrequencyBuySection.propTypes = {
  devices: array,
  collectionTitle: string,
  handleDeviceSelect: func
}

export default FrequencyBuySection
